require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2006-03-14-marketing-styles.json") })
        }
      }, "path---articles-2006-03-14-marketing-styles");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2006-03-14-marketing-styles!./.cache/json/articles-2006-03-14-marketing-styles.json
// module id = 458
// module chunks = 231608221292675